/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { context } from '@opentelemetry/api';
import { suppressTracing } from '@opentelemetry/core';
export class BatchLogProcessor {
    constructor(exporter, config) {
        this.logs = [];
        this.scheduledDelayMillis = (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) || 5000;
        this.exporter = exporter;
        window.addEventListener('unload', () => {
            this._flushAll();
        });
    }
    _flushAll() {
        this.lastBatchSent = Date.now();
        context.with(suppressTracing(context.active()), () => {
            const logsToExport = this.logs.splice(0, this.logs.length);
            this.exporter.export(logsToExport);
        });
    }
    onLog(log) {
        this.logs.push(log);
        if (this.timeout === undefined) {
            this.timeout = setTimeout(() => {
                this.timeout = undefined;
                this._flushAll();
            }, this.scheduledDelayMillis);
        }
    }
}
export function convert(body, timeUnixNano, attributes) {
    return {
        body,
        timeUnixNano,
        attributes,
    };
}
//# sourceMappingURL=BatchLogProcessor.js.map